import { Avatar as AvatarBase } from '@mui/material';
import React, { FC } from 'react';

import { getBgColor, getTitle } from 'Modules/ui/components';

import { Typography } from '../Typography';
import { AvatarProps } from './types';
import { AvatarPropsBySize, TypographyVariantBySize } from './utils';


export * from './types';

export const Avatar: FC<AvatarProps> = ({
    sx, isExact = false, size = 'L', round,
    bgColor, children, color, ...props
}) => (
    <AvatarBase
        sx={[
            ({ spacing }) => ({
                bgcolor: bgColor || (typeof children === 'string' ? getBgColor(children) : 'general.primary50'),
                width: spacing(AvatarPropsBySize[size].width),
                height: spacing(AvatarPropsBySize[size].width),
                borderRadius: round ? 50 : AvatarPropsBySize[size].borderRadius,
                fontSize: spacing(AvatarPropsBySize[size].iconSize),
                color,
            }),
            ...Array.isArray(sx) ? sx : [sx],
        ]}
        {...props}
    >
        {typeof children === 'string' ? (
            <Typography variant={TypographyVariantBySize[size]} color={color || 'grayscale.shade0'}>
                {getTitle(isExact, children)}
            </Typography>
        ) : children}
    </AvatarBase>
);
